module.exports = __webpack_public_path__ + "Lato-Hairline.c27ae7852e3ba0749f09.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Hairline.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Hairline.eot
// module chunks = styles